<template>
<div class="calendar">
  <div class="calendar__controls pure-g">
    <span class="pure-u-1-5">
      <a class="calendar__prev pure-button calendar__nav-button" @click="prevMonth" title="Previous Month">
        <i class="icon-angle-left"></i>
      </a>
    </span>
    <form class="pure-form controls__form pure-u-3-5">
      <select v-model.number="monthInput" class="controls__form__month">
        <option v-for="(month, index) in months" :value="(index + 1)">{{month}}</option>
      </select>
      <input type="number" v-model.number="yearInput" class="controls__form__year">
    </form>
    <span class="pure-u-1-5">
      <a class="calendar__next pure-button calendar__nav-button" @click="nextMonth" title="Next Month">
        <i class="icon-angle-right"></i>
      </a>
    </span>
  </div>
  <table cellspacing=0 class="calendar__table pure-table pure-table-bordered">
    <caption class="calendar__table__caption">{{title}}</caption>
    <thead>
      <th class="cell-header" v-for="day in days">{{day}}</th>
    </thead>
    <tbody>
      <tr v-for="week in calendarWeeks">
        <td class="calendar__day" v-for="dateParam in week">
          <a v-if="dateParam" @click="selectDate(dateParam)" >{{dateParam}}</a>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
</template>
<script>

const months = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const today = new Date();

export default {
  name: "calendar",
  data() {
    return {
      days,
      months,
    };
  },
  computed: {
    title() {
      return `${months[this.month - 1]} ${this.year}`;
    },
    monthInput: {
      get() {
        return this.month;
      },
      set(month) {
        this.$emit("updateMonthYear", { year: this.year, month });
      },
    },
    yearInput: {
      get() {
        return this.year;
      },
      set(year) {
        this.$emit("updateMonthYear", { year, month: this.month });
      },
    },
    calendarWeeks() {
      const weeks = [];
      const year = this.year;
      const month = this.month;
      const startDate = new Date(year, month - 1, 1);
      const endDate = new Date(year, month, 0);
      let week = [];
      let i;
      let dayCounter = 0;

      for (i = 0; i < startDate.getDay(); i += 1) {
        week.push(null);
        dayCounter += 1;
      }

      for (i = startDate.getDate(); i <= endDate.getDate(); i += 1) {
        dayCounter += 1;
        week.push(i);
        if (dayCounter % 7 === 0) {
          weeks.push(week);
          week = [];
        }
      }
      if (week.length > 0) {
        if (week.length < 7) {
          for (i = week.length; i < 7; i += 1) {
            week.push(null);
          }
        }
        weeks.push(week);
      }

      return weeks;
    },
  },
  props: {
    year: {
      type: Number,
      default: today.getFullYear(),
    },
    month: {
      type: Number,
      default: today.getMonth() + 1,
    },
  },
  methods: {
    prevMonth() {
      let month = this.month;
      let year = this.year;
      month -= 1;
      if (month < 1) {
        month = 12;
        year -= 1;
      }
      this.$emit("updateMonthYear", { year, month });
    },
    nextMonth() {
      let month = this.month;
      let year = this.year;
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
      this.$emit("updateMonthYear", { year, month });
    },
    selectDate(date) {
      this.$emit("selectDate", { year: this.year, month: this.month, date });
    },
  },
};
</script>
<style lang="scss">
  .calendar {
    overflow-x: auto;
    padding: 1em 1.5em;
    background: #eee;
  }
  .calendar__controls {
    margin-bottom: 0.5em;
  }
  .calendar__table {
    width: 100%;
  }
  .calendar__table__caption {
    display: none;
  }
  .calendar__nav-button {
    background: #AAA;
  }
  .calendar__day {
  }
  .calendar__day, .cell-header {
    text-align: center;
  }
  .calendar__controls {
    clear: both;
  }
  .calendar__prev {

  }
  .calendar__next {
    float: right;
  }
  .pure-form.controls__form {
    text-align: center;
    .controls__form__month, .controls__form__year {
      margin-bottom: 0;
      height: 2.25em;
      display: inline-block;
    }
  }
  .controls__form__year {
    width: 5em;
  }
  .controls__form__month {

  }
  .calendar__day a {
    cursor: pointer;
    display: block;
    line-height: 3.5em;
  }
  @media screen and (max-width: 35.5em) {
    .calendar {
      font-size: 0.7em;
    }
  }
</style>



// WEBPACK FOOTER //
// Calendar.vue?41e926a0